import { createEvent } from 'effector';

export const changeCenterHomeFiltersEv = createEvent();

export const resetCenterHomeFiltersEv = createEvent();

export const applyFiltersEv = createEvent();

export const changeHexPropEv = createEvent();

export const initCHStoreEv = createEvent();

export const togglePriceTypeEv = createEvent();

export const changeMobilePopupEv = createEvent();

export const resetMobilePopupEv = createEvent();
